import {
  getScheduleV2,
  getScheduleLevelDetail,
  updateTemplate,
  updateLevelOfSchedule
} from '@/api/patient/schedule.js'

const getDefaultState = () => (
  {
    endedScheduleList: [],
    currentSchedule: {
      id: null,
      title: '',
      advice: '',
      mustKnow: [],
      situations: [],
      careTips: [],
      level: [],
      currentLv: 0,
      isAutoUpgrade: false,
      assigner: {
        id: '',
        name: '',
        avatar: '',
        type: ''
      }
    },
    loadedInfo: {
      loadedPatientId: null,
      loadedTime: 0,
      loadedLevel: []
    }
  }
)

const state = getDefaultState()

const getters = {
  getCurrentSchedule: state => {
    return state.currentSchedule
  },
  getEndedScheduleList: state => {
    return state.endedScheduleList
  },
  getLoadedTime: state => {
    return state.loadedInfo.loadedTime
  },
  getLoadedId: state => {
    return state.loadedInfo.loadedPatientId
  }
}

const mutations = {
  SET_LOADED_INFO: (state, { loadedPatientId, loadedTime }) => {
    state.loadedInfo.loadedPatientId = loadedPatientId
    state.loadedInfo.loadedTime = loadedTime
    state.loadedInfo.loadedLevel = []
  },
  SET_ENDED_SCHEDULE_LIST: (state, endedScheduleList) => {
    state.endedScheduleList = endedScheduleList
  },
  SET_CURRENT_SCHEDULE: (state, schedule) => {
    state.currentSchedule = schedule
  },
  SET_CURRENT_SCHEDULE_LEVEL_BY_LEVEL: (state, { level = null, levelData = null }) => {
    if (!level && String(level) !== '0') return
    if (!levelData) return
    state.currentSchedule.level[level - 1] = levelData
    // NOTE: 緩存已經點擊過的 Level 資料
    state.loadedInfo.loadedLevel.push(level)
  },
  UPDATE_CURRENT_SCHEDULE_LEVEL_BY_INDEX: (state, { index = null, levelData = null }) => {
    if (!index && String(index) !== '0') return
    if (!levelData) return
    state.currentSchedule.level[index] = levelData
  },
  SET_ENDED_SCHEDULE_LEVEL: (state, { scheduleId = null, level = null, levelData = null }) => {
    if (!scheduleId) return
    if (!level && String(level) !== '0') return
    if (!levelData) return
    const endedScheduleIndex = state.endedScheduleList.findIndex(item => item.id === scheduleId)
    state.endedScheduleList[endedScheduleIndex].level[level - 1] = levelData
  },
  RESET_LOADED_TIME: (state, id) => {
    if (state.loadedInfo.loadedPatientId === id) {
      state.loadedInfo.loadedTime = 0
    }
  },
  // 重置 state
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  fetchSchedule ({ commit }, id) {
    return new Promise((resolve, reject) => {
      getScheduleV2(id, 1)
        .then(response => {
          const { active, ended } = response.data

          commit('SET_LOADED_INFO', {
            loadedPatientId: id,
            loadedTime: new Date().getTime()
          })

          commit('SET_CURRENT_SCHEDULE', active)
          commit('SET_ENDED_SCHEDULE_LIST', ended)

          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchScheduleLevelDetail ({ commit, state }, level) {
    if (state.loadedInfo.loadedLevel.includes(level)) return
    return new Promise((resolve, reject) => {
      getScheduleLevelDetail(state.loadedInfo.loadedPatientId, state.currentSchedule.id, level)
        .then(response => {
          const levelData = response.data

          commit('SET_CURRENT_SCHEDULE_LEVEL_BY_LEVEL', { level, levelData })

          resolve(levelData)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchEndedScheduleLevelDetail ({ commit, state }, { scheduleId = null, level = null }) {
    return new Promise((resolve, reject) => {
      getScheduleLevelDetail(state.loadedInfo.loadedPatientId, scheduleId, level)
        .then(response => {
          const levelData = response.data

          commit('SET_ENDED_SCHEDULE_LEVEL', { scheduleId, level, levelData })

          resolve(levelData)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateSchedule ({ commit, dispatch }, { id = null, data = {}, message = '', hasUndoBtn = true } = {}) {
    return new Promise((resolve, reject) => {
      if (!id) reject(new Error('[CZN error]: no patient id !!'))
      if (!data) reject(new Error('[CZN error]: no data to send！！'))
      updateTemplate(id, data)
        .then(_ => {
          if (hasUndoBtn) {
            dispatch('handleUndo', { id, message })
          }
          commit('SET_CURRENT_SCHEDULE', data)
          if (!hasUndoBtn) dispatch('notify/setMessage', { text: message }, { root: true })
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  handleUndo ({ state, dispatch }, { id = null, message = '' } = {}) {
    return new Promise((resolve) => {
      const tmpSchdule = state.currentSchedule
      dispatch('notify/setMessage', {
        text: message,
        undoFunction: () => {
          dispatch('updateSchedule', {
            id: id,
            data: tmpSchdule,
            message: '',
            hasUndoBtn: false
          })
        }
      }, { root: true })
      resolve()
    })
  },
  updateLevelOfCurrentSchedule ({ commit, state }, { id = null, modifyLevelData } = {}) {
    return new Promise((resolve) => {
      const level = modifyLevelData.level
      const modifyLevelIndex = modifyLevelData.level - 1
      const requestData = Object.assign({}, state.currentSchedule.level[modifyLevelIndex], modifyLevelData)
      updateLevelOfSchedule(id, level, requestData)
        .then(_ => {
          commit('UPDATE_CURRENT_SCHEDULE_LEVEL_BY_INDEX', { index: modifyLevelIndex, levelData: requestData })
          resolve()
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/modules/schedule.js